import { RankingSnapshot } from '../services/api';

/**
 * Convert ranking data to CSV format and trigger download
 */
export const exportRankingToCSV = (
  rankings: RankingSnapshot[], 
  timestamp: string,
  filename?: string
) => {
  // Define all columns to export (complete data from database)
  const headers = [
    'Posição',
    'SKU',
    'Nome Produto',
    'Score Final',
    'Score Base',
    'Penalização Aplicada',
    'Notas',
    'Preço Atual',
    'Preço Anterior',
    'Mudança Preço %',
    'Stock Quantidade',
    'Receita Total (7d)',
    'Quantidade Total (7d)',
    'DPD 0',
    'DPD 1',
    'DPD 3',
    'DPD 7',
    'Última Venda (Timestamp)',
    'Penalização V2 - Fator',
    'Penalização V2 - Categoria',
    'Horas Ativas em Atraso',
    'DPD Esperado Atual',
    'DPD Esperado Anterior',
    'Impacto Previsto DPD %',
    'Categoria Código',
    'Categoria Nome',
    'Marca Código',
    'Marca Nome',
    'Vendas 6 Dias',
    'Vendas Históricas',
    'Potencial de Vendas',
    'Score Elasticidade',
    'Receita Categoria',
    'Receita Marca',
    // Normalized scores
    'Norm Revenue',
    'Norm Stock',
    'Norm Category',
    'Norm Brand',
    'Norm Potential',
    'Norm Quantity',
    'Norm Price',
    // Weighted scores
    'Weighted Revenue',
    'Weighted Stock',
    'Weighted Category',
    'Weighted Brand',
    'Weighted Potential',
    'Weighted Quantity',
    'Weighted Price',
    'Timestamp Cálculo',
    'Timestamp Processamento'
  ];

  // Convert data to CSV rows
  const rows = rankings.map(r => [
    r.ranking_position || '',
    r.sku || '',
    r.product_name || '',
    r.final_score || '',
    r.base_score || '',
    r.penalty_applied || '',
    r.notas || '',
    r.preco_atual || '',
    r.preco_anterior || '',
    r.mudanca_preco_pct || '',
    r.stock_quantity || '',
    r.revenue_total || '',
    r.quantity_total || '',
    r.dpd_0 || '',
    r.dpd_1 || '',
    r.dpd_3 || '',
    r.dpd_7 || '',
    r.last_sale_timestamp || '',
    r.penalty_v2_factor || '',
    r.penalty_v2_category || '',
    r.active_hours_overdue || '',
    r.dpd_esperado_atual || '',
    r.dpd_esperado_anterior || '',
    r.impacto_previsto_dpd_pct || '',
    r.categoria_codigo || '',
    r.categoria_nome || '',
    r.marca_codigo || '',
    r.marca_nome || '',
    r.vendas_6_dias || '',
    r.vendas_historicas || '',
    r.potential_sales || '',
    r.elasticity_score || '',
    r.category_revenue || '',
    r.brand_revenue || '',
    // Normalized scores
    r.norm_revenue || '',
    r.norm_stock || '',
    r.norm_category || '',
    r.norm_brand || '',
    r.norm_potential || '',
    r.norm_quantity || '',
    r.norm_price || '',
    // Weighted scores
    r.weighted_revenue || '',
    r.weighted_stock || '',
    r.weighted_category || '',
    r.weighted_brand || '',
    r.weighted_potential || '',
    r.weighted_quantity || '',
    r.weighted_price || '',
    r.calculation_timestamp || '',
    r.processed_at || ''
  ]);

  // Create CSV content with BOM for Excel compatibility
  const BOM = '\uFEFF';
  const csvContent = BOM + 
    headers.join(';') + '\n' +
    rows.map(row => 
      row.map(cell => {
        // Escape quotes and wrap in quotes if contains comma or semicolon
        const cellStr = String(cell);
        if (cellStr.includes(';') || cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
          return `"${cellStr.replace(/"/g, '""')}"`;
        }
        return cellStr;
      }).join(';')
    ).join('\n');

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  
  // Format filename with timestamp
  const dateStr = timestamp ? new Date(timestamp).toISOString().slice(0, 19).replace(/:/g, '-') : new Date().toISOString().slice(0, 19).replace(/:/g, '-');
  const finalFilename = filename || `ranking_snapshot_${dateStr}.csv`;
  
  link.setAttribute('href', url);
  link.setAttribute('download', finalFilename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  
  // Clean up
  URL.revokeObjectURL(url);
};

/**
 * Export filtered ranking data (for current view)
 */
export const exportFilteredRankingToCSV = (
  rankings: RankingSnapshot[],
  timestamp: string,
  filters?: {
    search?: string;
    category?: string;
    brand?: string;
  }
) => {
  // Add filter info to filename
  let filenameParts = ['ranking_snapshot'];
  
  if (filters?.search) {
    filenameParts.push(`search_${filters.search}`);
  }
  if (filters?.category) {
    filenameParts.push(`cat_${filters.category}`);
  }
  if (filters?.brand) {
    filenameParts.push(`brand_${filters.brand}`);
  }
  
  const dateStr = timestamp ? new Date(timestamp).toISOString().slice(0, 19).replace(/:/g, '-') : new Date().toISOString().slice(0, 19).replace(/:/g, '-');
  filenameParts.push(dateStr);
  
  const filename = filenameParts.join('_') + '.csv';
  
  exportRankingToCSV(rankings, timestamp, filename);
};